import { Button, Input, PasswordInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Page from '@/components/Page.tsx';

import { signIn } from '@/services/authService.ts';

interface LoginForm {
    email: string;
    password: string;
}

const LoginPage: FC = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const form = useForm<LoginForm>({
        mode: 'uncontrolled',
        validateInputOnBlur: true,

        validate: {
            email: (value) => (/^\S+@\S+$/.test(value) ? undefined : t('validation.invalidEmail')),
        },
    });

    const onSubmit = async (values: LoginForm): Promise<void> => {
        setLoading(true);
        try {
            await signIn(values.email, values.password);
        } catch (error) {
            console.debug(error);
            // TODO: handle error types
        }
        setLoading(false);
    };

    return (
        <Page className="justify-center gap-8" fullScreen>
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Input.Wrapper label="Email">
                    <Input disabled={loading} {...form.getInputProps('email')} />
                </Input.Wrapper>{' '}
                <Input.Wrapper label="Password">
                    <PasswordInput disabled={loading} {...form.getInputProps('password')} />
                </Input.Wrapper>
                <Button loading={loading} type="submit">
                    {t('auth.signIn')}
                </Button>
            </form>
        </Page>
    );
};

export default LoginPage;
